// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SplashScreen_wrapper__e1fDb","logo":"SplashScreen_logo__3OwCB","text":"SplashScreen_text__RaJmh","bigText":"SplashScreen_bigText__1EH85","cta":"SplashScreen_cta__2nq2D"};